import React, { forwardRef } from 'react';
import styles from './FJRetry.module.less';
import FJRetryIcon from '../../../assets/svg/retry.svg?react';
import classNames from 'classnames';

const FJRetry = (props, ref) => {
    const { refreshCallback, isShow, className } = props;

    const refresh = e => {
        e.stopPropagation();
        if (refreshCallback) {
            refreshCallback(e);
        }
    };

    const boxCn = classNames(styles.box, { [styles.show]: isShow }, className);

    return (
        <div onClick={refresh} className={boxCn} ref={ref}>
            <FJRetryIcon className={styles.icon} />
        </div>
    );
};

export default forwardRef(FJRetry);
